// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type EnterpriseContractPolicyType = 'CONTRACT_FULLY_UTILIZED' | 'CONTRACT_ENDED';

export interface DowngradeEnterpriseContractJobConfig {
  enterpriseContractId: string;
  sendMembershipDeletionNotification: boolean;
  enterpriseContractIds: Array<string>;
  dryRun: boolean;
}

export interface StoredContractMigrationId {
  id: string;
}

export interface EnterpriseContractRenewalContractConfig {
  renewalContractId: string;
  contractMigrationId: StoredContractMigrationId;
}

export interface ContractEndedPolicyMetadata {
  downgradeContractConfiguration: DowngradeEnterpriseContractJobConfig;
  renewalContractConfiguration?: EnterpriseContractRenewalContractConfig | null;
}

export interface EnterpriseContractPolicyMetadataContractEndedPolicyMetadata {
  typeName: 'ContractEndedPolicyMetadata';
  definition: ContractEndedPolicyMetadata;
}

export interface ContractFullyUtilizedPolicyMetadata {
  fallbackContractId: string;
}

export interface EnterpriseContractPolicyMetadataContractFullyUtilizedPolicyMetadata {
  typeName: 'ContractFullyUtilizedPolicyMetadata';
  definition: ContractFullyUtilizedPolicyMetadata;
}

export type EnterpriseContractPolicyMetadata =
  | EnterpriseContractPolicyMetadataContractEndedPolicyMetadata
  | EnterpriseContractPolicyMetadataContractFullyUtilizedPolicyMetadata;

export type EnterpriseContractPolicyMetadataTypeName =
  | 'ContractEndedPolicyMetadata'
  | 'ContractFullyUtilizedPolicyMetadata';

export interface EnterpriseContractPoliciesV1 {
  id: string;
  contractId: string;
  policyType: EnterpriseContractPolicyType;
  metadata: EnterpriseContractPolicyMetadata;
  updatedAt: number;
  updatedBy: number;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface EnterpriseContractPoliciesV1Connection {
  elements: Array<EnterpriseContractPoliciesV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface EnterpriseContractPoliciesV1ByContractQuery {
  EnterpriseContractPoliciesV1: {
    byContract: EnterpriseContractPoliciesV1Connection | null;
  } | null;
}

export interface EnterpriseContractPoliciesV1ByContractQueryVariables {
  enterpriseContractId: string;
  includes?: string | null;
}

export interface EnterpriseContractPoliciesV1ByContractPolicyIdQuery {
  EnterpriseContractPoliciesV1: {
    byContractPolicyId: EnterpriseContractPoliciesV1Connection | null;
  } | null;
}

export interface EnterpriseContractPoliciesV1ByContractPolicyIdQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseContractPoliciesV1ByFallbackContractQuery {
  EnterpriseContractPoliciesV1: {
    byFallbackContract: EnterpriseContractPoliciesV1Connection | null;
  } | null;
}

export interface EnterpriseContractPoliciesV1ByFallbackContractQueryVariables {
  fallbackContractId: string;
  includes?: string | null;
}

export interface EnterpriseContractPoliciesV1ByRenewalContractQuery {
  EnterpriseContractPoliciesV1: {
    byRenewalContract: EnterpriseContractPoliciesV1Connection | null;
  } | null;
}

export interface EnterpriseContractPoliciesV1ByRenewalContractQueryVariables {
  renewalContractId: string;
  includes?: string | null;
}

export interface EnterpriseContractPoliciesV1DeleteQuery {
  EnterpriseContractPoliciesV1: {
    delete: EnterpriseContractPoliciesV1Connection | null;
  } | null;
}

export interface EnterpriseContractPoliciesV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface EnterpriseContractPoliciesV1GetQuery {
  EnterpriseContractPoliciesV1: {
    get: EnterpriseContractPoliciesV1Connection | null;
  } | null;
}

export interface EnterpriseContractPoliciesV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface EnterpriseContractPoliciesV1CreateMutation {
  EnterpriseContractPoliciesV1: {
    create: EnterpriseContractPoliciesV1Connection | null;
  } | null;
}

export interface EnterpriseContractPoliciesV1CreateMutationVariables {
  requestingUserId?: string | null;
  includes?: string | null;
}

export interface EnterpriseContractPoliciesV1GetAllActiveFallbackContractIdsMutation {
  EnterpriseContractPoliciesV1: {
    getAllActiveFallbackContractIds: EnterpriseContractPoliciesV1Connection | null;
  } | null;
}

export interface EnterpriseContractPoliciesV1GetAllActiveFallbackContractIdsMutationVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class EnterpriseContractPoliciesV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseContractPolicies.v1' as const;

  declare id: string;

  declare contractId: string;

  declare policyType: EnterpriseContractPolicyType;

  declare metadata: EnterpriseContractPolicyMetadata;

  declare updatedAt: number;

  declare updatedBy: number;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<EnterpriseContractPoliciesV1>) {
    super(params);
  }
}
